import { Consume } from '../../../Context/Consumer';
import React, { Component } from 'react';
import { PlayerListContext, TransContext, TeamDataContext } from '../../../Context';
import { getTrans, makeClasses, customTracking, getPageName } from '../../../common';
import { Scrollbars } from 'react-custom-scrollbars';
import config from '../../../common/config';
import OutsideNotifier from '../../../components/OutsideNotifier'

class WebPlayerStatusFilter extends Component {

    constructor(props) {
        super(props)
        this.state = {
            openPlayerStatus: false
        }
        this.playerSortByArr = config.playerFilters.playerStatus;
    }

    onSortOpen = (value) => {

        if (value != undefined) {
            this.setState({
                openPlayerStatus: false
            })
        } else {
            this.setState({
                openPlayerStatus: !this.state.openPlayerStatus
            })
        }
    }

    setSortBy = (sort) => {


    }

    resetSortBy = (e) => {
        e.stopPropagation();

        for (var i = 0; i < this.props.PlayerListData.playerListFilters.playerStatus.length; i++) {
            this.props.PlayerListData.playerListFilters.playerStatus[i].active = false;
        }

        let budget = this.props.TeamData.data.budget;
        this.props.PlayerListData.setPlayerFilters(this.props.PlayerListData.playerListFilters, budget);
    }

    getActiveStatus = () => {
        let count = 0
        for (var i = 0; i < this.props.PlayerListData.playerListFilters.playerStatus.length; i++) {
            if (this.props.PlayerListData.playerListFilters.playerStatus[i].active) {
                count = count + 1;
            }
        }

        return count
    }

    onSortApply = (e, sortOption) => {
        e.stopPropagation();
        this.props.PlayerListData.playerListFilters.playerStatus.map((statusObj) => {
            if (sortOption.id == statusObj.id) {
                statusObj.active = !statusObj.active
                if (statusObj.active) {
                    customTracking('Select Show Filter - ' + sortOption.labelTrck, getPageName());
                }
            }
        });
        let budget = this.props.TeamData.data.budget;
        this.props.PlayerListData.setPlayerFilters(this.props.PlayerListData.playerListFilters, budget);

    };


    render() {

        let { PlayerListData, TransData } = this.props;
        let trans = TransData.data;
        let isAnyStatusFilterActive = this.getActiveStatus();
        this.playerSortByArr = PlayerListData.playerListFilters.playerStatus;


        return (

            <div className={ this.state.openPlayerStatus ? "si-dropdown__wrap si-dropdown--white si-show" : "si-dropdown__wrap si-dropdown--white" }>
                <div className="si-dropdown__btn si-curved" onClick={ () => { this.onSortOpen() } }>
                    <div className="si-dropdown__txt">{ this.getActiveStatus() ?

                        <div className="si-selected-clubs">
                            { this.playerSortByArr.map((el) => {
                                if (el.active) {
                                    return <div className="si-img-wrap" title={ el.label } onClick={ (e) => { this.onSortApply(e, el) } } key={ el.label }>
                                        <i className={ el.siIcon }></i>
                                    </div>
                                } else {
                                    return null
                                }

                            }) }
                        </div>
                        : getTrans(trans, "dropDwonPlystatus", "Status") }</div>




                    <div className="si-dropdown__action">
                        { isAnyStatusFilterActive ? <div className="si-icon euro-cross-round" onClick={ (e) => { this.resetSortBy(e) } }></div> : null }
                        <div className="si-dropdown__close euro-drop-down"></div>
                    </div>
                </div>
                { this.state.openPlayerStatus ?
                    <OutsideNotifier
                        handler={ () => this.onSortOpen(false) }>
                        <ul className="si-dropdown__menu">
                            { this.playerSortByArr.map((el) => {
                                const className = makeClasses({
                                    'si-active': el.active,
                                    'si-dropdown__item': true
                                })

                                return <li onClick={ (e) => { this.onSortApply(e, el) } } key={ el.label }>
                                    <div className={ className }>
                                        <div className="si-checkbox">
                                            <input type="checkbox" { ...{ checked: el.active } } onChange={ () => { } } />
                                            <div className="si-check-mark"></div>
                                        </div>
                                        <div className="si-img-wrap">
                                            <i className={ el.siIcon }></i>
                                            <span>{ getTrans(trans, el.label, el.label) }</span>
                                        </div>
                                    </div>
                                </li>
                            }) }


                        </ul>
                    </OutsideNotifier> : null
                }
            </div>

        )
    }

}


export default (Consume(WebPlayerStatusFilter, [PlayerListContext, TransContext, TeamDataContext]));







